import { UserIdentityConflictDefinition } from '~src/authentication/contentDefinitions/UserIdentityConflictDefinition';
import { setContentSpaceDefinitions, setExplorableItemDefinitions, setFavoriteMixedContentInOrder, setMixedContentInOrder, setPersonalSpaceContentInOrder } from '~src/contentDefinitionInterfaces/ContentDefinitionsLists';
import { ExplorableItemDefinition, MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { MetricDefinition } from '~src/metrics/models/MetricDefinition';
import { ExplorableItemType, SpaceInfoItemType } from '~src/ts/models/ContentType';

import { DatasourceDefinition } from '../datasource/components/contentDefinitions/DatasourceDefinition';
import { WorkbookDefinition } from '../workbook/components/contentDefinitions/WorkbookDefinition';
import { AccelerationTaskDefinition } from './AccelerationTaskDefinition';
import { BackgroundJobDefinition } from './BackgroundJobDefinition';
import { CollectionDefinition } from './CollectionDefinition';
import { ConnectedWorkbooksInDatasourceDefinition } from './ConnectedWorkbooksInDatasourceDefinition';
import { CustomViewDefinition } from './CustomViewDefinition';
import { DataAlertDefinition } from './DataAlertDefinition';
import { DatabaseDefinition, DatabaseWithCrassDefinition } from './DatabaseDefinition';
import { DataConnectionDefinition } from './DataConnectionDefinition';
import { DataConnectionInDatasourceDefinition } from './DataConnectionInDatasourceDefinition';
import { DataRoleDefinition } from './DataRoleDefinition';
import { ExtractTaskDefinition } from './ExtractTaskDefinition';
import { FlowDefinition } from './FlowDefinition';
import { FlowOutputStepRunDefinition } from './FlowOutputStepRunDefinition';
import { GroupDefinition } from './GroupDefinition';
import { LensDefinition } from './LensDefinition';
import { ProjectDefinition } from './ProjectDefinition';
import { PublishedConnectionDefinition } from './PublishedConnectionDefinition';
import { PublishedConnectionTableDefinition } from './PublishedConnectionTableDefinition';
import { RecommendedViewDefinition } from './RecommendedViewDefinition';
import { RemoteRefreshSchedulesDefinition } from './RemoteRefreshSchedulesDefinition';
import { ResourceGovernanceSettingDefiniton } from './ResourceGovernanceSettingDefinition';
import { RunFlowTaskDefinition } from './RunFlowTaskDefinition';
import { ScheduleDefinition } from './ScheduleDefinition';
import { SearchUserDefinition } from './SearchUserDefinition';
import { ServerUserDefinition } from './ServerUserDefinition';
import { SiteDefinition } from './SiteDefinition';
import { SiteUserDefinition } from './SiteUserDefinition';
import { SubscriptionDefinition } from './SubscriptionDefinition';
import { TableDefinition, TableWithCrassDefinition } from './TableDefinition';
import { ViewDefinition } from './ViewDefinition';
import { WorkbookAccelerationDefinition } from './WorkbookAccelerationDefinition';



const mixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  LensDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  PublishedConnectionDefinition,
];

const personalSpaceContentInOrder: MixedContentItemDefinition[] = [
  WorkbookDefinition,
  DatasourceDefinition,
];

const favoriteMixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  CollectionDefinition,
  PublishedConnectionDefinition,
];

const explorableItemDefinitions: Record<ExplorableItemType, ExplorableItemDefinition> = {
  accelerationTask: AccelerationTaskDefinition,
  backgroundJob: BackgroundJobDefinition,
  collection: CollectionDefinition,
  connectedWorkbook: ConnectedWorkbooksInDatasourceDefinition,
  connection: DataConnectionInDatasourceDefinition,
  customView: CustomViewDefinition,
  dataalert: DataAlertDefinition,
  database: DatabaseDefinition,
  databaseWithCrass: DatabaseWithCrassDefinition,
  dataconnection: DataConnectionDefinition,
  dataRole: DataRoleDefinition,
  datasource: DatasourceDefinition,
  extractTask: ExtractTaskDefinition,
  flow: FlowDefinition,
  flowOutputStepRun: FlowOutputStepRunDefinition,
  group: GroupDefinition,
  lens: LensDefinition,
  metric: MetricDefinition,
  project: ProjectDefinition,
  publishedConnection: PublishedConnectionDefinition,
  publishedConnectionTable: PublishedConnectionTableDefinition,
  recommendedView: RecommendedViewDefinition,
  remoteRefreshSchedule: RemoteRefreshSchedulesDefinition,
  resourceGovernanceSetting: ResourceGovernanceSettingDefiniton,
  runFlowTask: RunFlowTaskDefinition,
  schedule: ScheduleDefinition,
  searchuser: SearchUserDefinition,
  serveruser: ServerUserDefinition,
  userIdentityConflict: UserIdentityConflictDefinition,
  site: SiteDefinition,
  siteuser: SiteUserDefinition,
  subscription: SubscriptionDefinition,
  table: TableDefinition,
  tableWithCrass: TableWithCrassDefinition,
  view: ViewDefinition,
  workbook: WorkbookDefinition,
  workbookAcceleration: WorkbookAccelerationDefinition,
};

const contentSpaceDefinitions: { [C in SpaceInfoItemType]: SpaceDefinition<C> } = {
  collection: CollectionDefinition,
  dataRole: DataRoleDefinition,
  datasource: DatasourceDefinition,
  flow: FlowDefinition,
  group: GroupDefinition,
  lens: LensDefinition,
  metric: MetricDefinition,
  project: ProjectDefinition,
  publishedConnection: PublishedConnectionDefinition,
  resourceGovernanceSetting: ResourceGovernanceSettingDefiniton,
  schedule: ScheduleDefinition,
  serveruser: ServerUserDefinition,
  siteuser: SiteUserDefinition,
  view: ViewDefinition,
  workbook: WorkbookDefinition,
};


setMixedContentInOrder(mixedContentInOrder);
setPersonalSpaceContentInOrder(personalSpaceContentInOrder);
setFavoriteMixedContentInOrder(favoriteMixedContentInOrder);
setExplorableItemDefinitions(explorableItemDefinitions);
setContentSpaceDefinitions(contentSpaceDefinitions);

